import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openFAQ, setOpenFAQ] = useState(null);
  const [activeResultTab, setActiveResultTab] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      {/* Navigation */}
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          <div className="logo">
            <div className="logo-icon">
              <img src="/logo.png" alt="Parwaaz Academy Logo" />
            </div>
            <div className="logo-text-wrapper">
              <span className="logo-text">Parwaaz</span>
              <span className="logo-subtitle">Academy</span>
              <span className="logo-tagline">Udaan Umeed Ki</span>
            </div>
          </div>
          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <li><a href="#home" onClick={() => setIsMenuOpen(false)}>Home</a></li>
            <li><a href="#about" onClick={() => setIsMenuOpen(false)}>About</a></li>
            <li className="nav-dropdown">
              <a href="#courses" onClick={(e) => {
                e.preventDefault();
                setIsMenuOpen(false);
                document.getElementById('courses')?.scrollIntoView({ behavior: 'smooth' });
              }}>
                Courses <span className="dropdown-arrow">▼</span>
              </a>
              <ul className="dropdown-menu">
                <li><a href="#courses" onClick={() => setIsMenuOpen(false)}>Foundation Classes</a></li>
                <li><a href="#courses" onClick={() => setIsMenuOpen(false)}>11th & 12th</a></li>
                <li><a href="#courses" onClick={() => setIsMenuOpen(false)}>NEET & JEE</a></li>
              </ul>
            </li>
            <li><a href="#results-section" onClick={() => setIsMenuOpen(false)}>Results</a></li>
            <li><a href="#testimonials" onClick={() => setIsMenuOpen(false)}>Testimonials</a></li>
            <li><a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact</a></li>
          </ul>
          <div className="nav-actions">
            <a href="https://my-skool.com/admission/PARWAAZ01" target="_blank" rel="noopener noreferrer" className="nav-cta-btn">
              <span>Register Now</span>
              <span className="cta-icon">→</span>
            </a>
            <button className={`nav-toggle ${isMenuOpen ? 'active' : ''}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
        <div className="nav-indicator"></div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-background">
          <div className="hero-particles">
            <div className="particle particle-1"></div>
            <div className="particle particle-2"></div>
            <div className="particle particle-3"></div>
            <div className="particle particle-4"></div>
            <div className="particle particle-5"></div>
            <div className="particle particle-6"></div>
          </div>
          <div className="hero-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
          </div>
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge">
              <span className="badge-icon">🎓</span>
              <span>Kashmir's Premier Coaching Institute</span>
            </div>
          <div className="hero-tagline">Udaan Umeed Ki</div>
          <h1 className="hero-title">
            <span className="gradient-text">Soar Higher</span> with Parwaaz Academy
          </h1>
          <p className="hero-subtitle">
            More than just coaching—we are a <strong>complete solution</strong> for parents who aspire to give their children the best future. 
            Transform ambitions into reality through personalized mentorship, AI-driven learning, and cutting-edge technology.
          </p>
            <div className="hero-buttons">
              <a href="https://my-skool.com/admission/PARWAAZ01" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                <span>Register Now</span>
                <span className="btn-icon">→</span>
              </a>
              <a href="#courses" className="btn btn-secondary">
                <span>Explore Courses</span>
              </a>
            </div>
            <div className="hero-stats">
              <div className="hero-stat">
                <div className="hero-stat-number">10K+</div>
                <div className="hero-stat-label">Students</div>
              </div>
              <div className="hero-stat-divider"></div>
              <div className="hero-stat">
                <div className="hero-stat-number">95%</div>
                <div className="hero-stat-label">Success Rate</div>
              </div>
              <div className="hero-stat-divider"></div>
              <div className="hero-stat">
                <div className="hero-stat-number">50+</div>
                <div className="hero-stat-label">Expert Faculty</div>
              </div>
              <div className="hero-stat-divider"></div>
              <div className="hero-stat">
                <div className="hero-stat-number">15+</div>
                <div className="hero-stat-label">Years Experience</div>
              </div>
            </div>
          </div>
          <div className="hero-images">
            <div className="hero-image-main">
              <div className="image-placeholder-main">
                <div className="placeholder-content">
                  <span className="placeholder-icon">📚</span>
                  <span className="placeholder-text">Students Learning</span>
                </div>
              </div>
              <div className="image-glow"></div>
            </div>
            <div className="hero-image-cards">
              <div className="floating-image-card card-1">
                <div className="card-image">
                  <span className="card-icon">🎯</span>
                </div>
                <div className="card-content">
                  <div className="card-title">NEET Success</div>
                  <div className="card-subtitle">30+ Selections</div>
                </div>
              </div>
              <div className="floating-image-card card-2">
                <div className="card-image">
                  <span className="card-icon">🏆</span>
                </div>
                <div className="card-content">
                  <div className="card-title">JEE Achievers</div>
                  <div className="card-subtitle">50+ Selections</div>
                </div>
              </div>
              <div className="floating-image-card card-3">
                <div className="card-image">
                  <span className="card-icon">👨‍🏫</span>
                </div>
                <div className="card-content">
                  <div className="card-title">Expert Faculty</div>
                  <div className="card-subtitle">50+ Teachers</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-indicator">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
          <span className="scroll-text">Scroll to explore</span>
        </div>
      </section>

      {/* Notice Board Section */}
      <section className="notice-board">
        <div className="container">
          <div className="notice-board-header">
            <h2 className="notice-title">📢 Notice Board</h2>
            <div className="notice-badge">Important</div>
          </div>
          <div className="notices-grid">
            <div className="notice-card registration">
              <div className="notice-icon">📝</div>
              <div className="notice-content">
                <h3>New Registrations Open</h3>
                <p>Enroll now for the upcoming academic session. Limited seats available!</p>
                <a href="https://my-skool.com/admission/PARWAAZ01" target="_blank" rel="noopener noreferrer" className="notice-link">Register Now →</a>
              </div>
              <div className="notice-badge-new">New</div>
            </div>
            <div className="notice-card results">
              <div className="notice-icon">🏆</div>
              <div className="notice-content">
                <h3>Results Declared</h3>
                <p>Check your NEET & JEE test results. Congratulations to all achievers!</p>
                <a href="#results-section" className="notice-link">View Results →</a>
              </div>
            </div>
            <div className="notice-card announcement">
              <div className="notice-icon">📢</div>
              <div className="notice-content">
                <h3>Upcoming Events</h3>
                <p>Join our free demo classes and scholarship test. Don't miss out!</p>
                <a href="#contact" className="notice-link">Learn More →</a>
              </div>
            </div>
          </div>
          <div className="notice-scroll">
            <div className="notice-scroll-wrapper">
              <div className="notice-scroll-content">
                <span className="scroll-badge">Latest:</span>
                <span>Admissions open for 10th, 11th, 12th, NEET & JEE batches •</span>
                <span>Free demo classes available •</span>
                <span>Scholarship test on 15th of every month •</span>
                <span>Online and offline classes available •</span>
              </div>
              <div className="notice-scroll-content" aria-hidden="true">
                <span className="scroll-badge">Latest:</span>
                <span>Admissions open for 10th, 11th, 12th, NEET & JEE batches •</span>
                <span>Free demo classes available •</span>
                <span>Scholarship test on 15th of every month •</span>
                <span>Online and offline classes available •</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">About Parwaaz</h2>
            <p className="section-subtitle">Your journey to excellence starts here</p>
          </div>
          <div className="about-content">
            <div className="about-text">
              <h3>Empowering Students in the Digital Age</h3>
              <p>
                Parwaaz Academy is dedicated to providing world-class education and 
                empowering students to achieve their full potential in the digital age.
              </p>
              <p>
                We are more than just a coaching institute—we are a complete solution 
                for parents who aspire to give their children the best future. Unlike 
                traditional coaching centers that focus only on exam preparation, we take 
                a holistic approach that recognizes every student's unique aspirations 
                and strengths.
              </p>
              <p>
                Whether students are aiming for <strong>MBBS, IIT</strong>, or other 
                prestigious competitive exams and professional courses, we customize our 
                teaching methods to fit their specific goals. Our philosophy is centered 
                on the belief that every student holds immense potential, and we dedicate 
                ourselves to working closely with each learner to turn their ambitions 
                into reality.
              </p>
              <p>
                Beyond academics, we equip students with essential skills to navigate 
                the ever-changing demands of the modern world. Our programs are carefully 
                designed to align with industry trends, ensuring students are ready to 
                succeed in their chosen careers.
              </p>
              <div className="stats">
                <div className="stat-item">
                  <div className="stat-number">10K+</div>
                  <div className="stat-label">Students Trained</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">95%</div>
                  <div className="stat-label">Success Rate</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">50+</div>
                  <div className="stat-label">Expert Faculty</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">15+</div>
                  <div className="stat-label">Years Experience</div>
                </div>
              </div>
            </div>
            <div className="about-image">
              <div className="image-placeholder">
                <div className="floating-card card-1"></div>
                <div className="floating-card card-2"></div>
                <div className="floating-card card-3"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Enhanced Statistics Section */}
      <section className="enhanced-stats">
        <div className="container">
          <div className="stats-banner">
            <h2 className="stats-banner-title">A Platform Trusted by Students</h2>
            <p className="stats-banner-subtitle">Parwaaz Academy aims to transform not just through words, but provide results with numbers!</p>
            <div className="enhanced-stats-grid">
              <div className="enhanced-stat-item">
                <div className="enhanced-stat-number">10K+</div>
                <div className="enhanced-stat-label">Happy Students</div>
              </div>
              <div className="enhanced-stat-item">
                <div className="enhanced-stat-number">50K+</div>
                <div className="enhanced-stat-label">Mock Tests</div>
              </div>
              <div className="enhanced-stat-item">
                <div className="enhanced-stat-number">24/7</div>
                <div className="enhanced-stat-label">Doubt Solving</div>
              </div>
              <div className="enhanced-stat-item">
                <div className="enhanced-stat-number">100+</div>
                <div className="enhanced-stat-label">Video Lectures</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Courses Section */}
      <section id="courses" className="courses">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Courses</h2>
            <p className="section-subtitle">Comprehensive programs designed for your success</p>
          </div>
          <div className="courses-grid">
            <div className="course-card">
              <div className="course-icon">📚</div>
              <h3>Foundation Classes</h3>
              <p>Strong conceptual learning for 8th to 10th class students to build a solid academic foundation. Perfect for school students starting their journey.</p>
              <ul className="course-features">
                <li>✓ Classes 8th to 10th</li>
                <li>✓ Strong Conceptual Learning</li>
                <li>✓ Solid Academic Foundation</li>
              </ul>
              <a href="https://my-skool.com/admission/PARWAAZ01" target="_blank" rel="noopener noreferrer" className="course-btn">Register Now</a>
            </div>
            <div className="course-card">
              <div className="course-icon">🎓</div>
              <h3>11th & 12th Classes</h3>
              <p>Expert coaching for Medical & Non-Medical streams under JKBOSE & CBSE syllabus. Comprehensive preparation for board exams and competitive entrance tests.</p>
              <ul className="course-features">
                <li>✓ Medical & Non-Medical Streams</li>
                <li>✓ JKBOSE & CBSE Syllabus</li>
                <li>✓ Expert Coaching</li>
              </ul>
              <a href="https://my-skool.com/admission/PARWAAZ01" target="_blank" rel="noopener noreferrer" className="course-btn">Register Now</a>
            </div>
            <div className="course-card featured">
              <div className="course-badge">Popular</div>
              <div className="course-icon">🎯</div>
              <h3>NEET & JEE Preparation</h3>
              <p>Comprehensive coaching for NEET & JEE aspirants with expert guidance and test series. Personalized mentorship to help you achieve your MBBS and IIT dreams.</p>
              <ul className="course-features">
                <li>✓ Expert Guidance</li>
                <li>✓ Comprehensive Test Series</li>
                <li>✓ Personalized Mentorship</li>
              </ul>
              <a href="https://my-skool.com/admission/PARWAAZ01" target="_blank" rel="noopener noreferrer" className="course-btn">Register Now</a>
            </div>
          </div>
        </div>
      </section>

      {/* Results Section */}
      <section id="results-section" className="results-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Academic Excellence: Results</h2>
            <p className="section-subtitle">Giving wings to dreams, one success story at a time</p>
          </div>
          <div className="results-tabs">
            <button 
              className={`result-tab ${activeResultTab === 0 ? 'active' : ''}`}
              onClick={() => setActiveResultTab(0)}
            >
              NEET Results
            </button>
            <button 
              className={`result-tab ${activeResultTab === 1 ? 'active' : ''}`}
              onClick={() => setActiveResultTab(1)}
            >
              JEE Results
            </button>
            <button 
              className={`result-tab ${activeResultTab === 2 ? 'active' : ''}`}
              onClick={() => setActiveResultTab(2)}
            >
              Board Results
            </button>
          </div>
          <div className="results-content">
            <div className={`result-category ${activeResultTab === 0 ? 'active' : ''}`}>
              <h3 className="result-category-title">NEET Results 2024</h3>
              <p className="result-category-subtitle">30+ Selections out of 100 Students</p>
              <div className="results-grid">
                <div className="result-card">
                  <div className="result-avatar">AQ</div>
                  <div className="result-info">
                    <h4>Amaan Qureshi</h4>
                    <p>MBBS, GMC Srinagar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">AK</div>
                  <div className="result-info">
                    <h4>Ayesha Khan</h4>
                    <p>MBBS, GMC Srinagar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">HM</div>
                  <div className="result-info">
                    <h4>Hassan Mir</h4>
                    <p>MBBS, GMC Srinagar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">SM</div>
                  <div className="result-info">
                    <h4>Sameer Mir</h4>
                    <p>MBBS, GMC Srinagar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">FA</div>
                  <div className="result-info">
                    <h4>Faisal Ahmad</h4>
                    <p>MBBS, GMC Srinagar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">ZA</div>
                  <div className="result-info">
                    <h4>Zainab Ali</h4>
                    <p>MBBS, GMC Srinagar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">IB</div>
                  <div className="result-info">
                    <h4>Ibrahim Bhat</h4>
                    <p>MBBS, SKIMS Srinagar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">NS</div>
                  <div className="result-info">
                    <h4>Nida Sheikh</h4>
                    <p>MBBS, GMC Srinagar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">UM</div>
                  <div className="result-info">
                    <h4>Umar Malik</h4>
                    <p>MBBS, GMC Srinagar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">SA</div>
                  <div className="result-info">
                    <h4>Sara Ahmad</h4>
                    <p>MBBS, SKIMS Srinagar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">YK</div>
                  <div className="result-info">
                    <h4>Yusuf Khan</h4>
                    <p>MBBS, GMC Srinagar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">FM</div>
                  <div className="result-info">
                    <h4>Fatima Mir</h4>
                    <p>MBBS, GMC Srinagar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={`result-category ${activeResultTab === 1 ? 'active' : ''}`}>
              <h3 className="result-category-title">JEE Results 2024</h3>
              <p className="result-category-subtitle">Record breaking 50+ Selections</p>
              <div className="results-grid">
                <div className="result-card">
                  <div className="result-avatar">RK</div>
                  <div className="result-info">
                    <h4>Rahul Kumar</h4>
                    <p>99.99 %ile - IIT Delhi</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">AS</div>
                  <div className="result-info">
                    <h4>Amit Singh</h4>
                    <p>99.70 %ile - IIT Bombay</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">PS</div>
                  <div className="result-info">
                    <h4>Priya Sharma</h4>
                    <p>99.50 %ile - IIT Kanpur</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">MM</div>
                  <div className="result-info">
                    <h4>Mohammad Muazzam</h4>
                    <p>99.42 %ile - IIT Kharagpur</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">SM</div>
                  <div className="result-info">
                    <h4>Simrah Mir</h4>
                    <p>99.39 %ile - IIT Roorkee</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">LA</div>
                  <div className="result-info">
                    <h4>Lone Ayaan</h4>
                    <p>99.24 %ile - IIT Hyderabad</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">AM</div>
                  <div className="result-info">
                    <h4>Arjun Malik</h4>
                    <p>99.15 %ile - IIT Madras</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">SK</div>
                  <div className="result-info">
                    <h4>Sneha Kapoor</h4>
                    <p>99.05 %ile - IIT Guwahati</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">VP</div>
                  <div className="result-info">
                    <h4>Vikram Patel</h4>
                    <p>98.95 %ile - IIT Indore</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">RD</div>
                  <div className="result-info">
                    <h4>Riya Desai</h4>
                    <p>98.85 %ile - IIT Varanasi</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">AJ</div>
                  <div className="result-info">
                    <h4>Aditya Joshi</h4>
                    <p>98.75 %ile - IIT Gandhinagar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">NK</div>
                  <div className="result-info">
                    <h4>Neha Khanna</h4>
                    <p>98.65 %ile - IIT Bhubaneswar</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">RS</div>
                  <div className="result-info">
                    <h4>Rohan Shah</h4>
                    <p>98.55 %ile - IIT Dhanbad</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">DM</div>
                  <div className="result-info">
                    <h4>Divya Mehta</h4>
                    <p>98.45 %ile - IIT Mandi</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">KG</div>
                  <div className="result-info">
                    <h4>Karan Gupta</h4>
                    <p>98.35 %ile - IIT Patna</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={`result-category ${activeResultTab === 2 ? 'active' : ''}`}>
              <h3 className="result-category-title">Board Results 2024</h3>
              <p className="result-category-subtitle">Outstanding performance across all streams</p>
              <div className="results-grid">
                <div className="result-card">
                  <div className="result-avatar">AA</div>
                  <div className="result-info">
                    <h4>Arham Ahmad</h4>
                    <p>95% - Science Stream</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">SK</div>
                  <div className="result-info">
                    <h4>Sara Khan</h4>
                    <p>94% - Medical Stream</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">IB</div>
                  <div className="result-info">
                    <h4>Ibrahim Bhat</h4>
                    <p>93% - Non-Medical</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">FM</div>
                  <div className="result-info">
                    <h4>Fatima Mir</h4>
                    <p>92% - Medical Stream</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">YK</div>
                  <div className="result-info">
                    <h4>Yusuf Khan</h4>
                    <p>91% - Science Stream</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">NS</div>
                  <div className="result-info">
                    <h4>Nida Sheikh</h4>
                    <p>90% - Commerce Stream</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">UM</div>
                  <div className="result-info">
                    <h4>Umar Malik</h4>
                    <p>89% - Non-Medical</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">SA</div>
                  <div className="result-info">
                    <h4>Sara Ahmad</h4>
                    <p>88% - Medical Stream</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">AM</div>
                  <div className="result-info">
                    <h4>Ayesha Mir</h4>
                    <p>87% - Science Stream</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">HM</div>
                  <div className="result-info">
                    <h4>Hassan Malik</h4>
                    <p>86% - Commerce Stream</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">ZA</div>
                  <div className="result-info">
                    <h4>Zainab Ali</h4>
                    <p>85% - Medical Stream</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="result-avatar">AQ</div>
                  <div className="result-info">
                    <h4>Amaan Qureshi</h4>
                    <p>84% - Non-Medical</p>
                    <span className="result-year">2024</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Section */}
      <section id="technology" className="technology">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Cutting-Edge Technology</h2>
            <p className="section-subtitle">International standards, right here</p>
          </div>
          <div className="tech-content">
            <div className="tech-text">
              <h3>State-of-the-Art IT Department</h3>
              <p>
                Our IT department matches international benchmarks, bringing the latest 
                advancements in education technology and AI-driven learning tools—practices 
                that are being implemented in Europe and other developed nations—right to 
                our students.
              </p>
              <div className="tech-features">
                <div className="tech-feature-item">
                  <div className="tech-icon">🤖</div>
                  <div>
                    <h4>AI-Driven Learning</h4>
                    <p>Personalized learning paths powered by artificial intelligence</p>
                  </div>
                </div>
                <div className="tech-feature-item">
                  <div className="tech-icon">🌐</div>
                  <div>
                    <h4>Global Standards</h4>
                    <p>Technology matching practices from developed nations</p>
                  </div>
                </div>
                <div className="tech-feature-item">
                  <div className="tech-icon">📊</div>
                  <div>
                    <h4>Advanced Analytics</h4>
                    <p>Data-driven insights for continuous improvement</p>
                  </div>
                </div>
                <div className="tech-feature-item">
                  <div className="tech-icon">🚀</div>
                  <div>
                    <h4>Future-Ready Tools</h4>
                    <p>Access to cutting-edge resources and global-level opportunities</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="tech-visual">
              <div className="tech-card tech-card-1">
                <div className="tech-card-icon">💻</div>
                <p>AI Learning Platform</p>
              </div>
              <div className="tech-card tech-card-2">
                <div className="tech-card-icon">📱</div>
                <p>Mobile Learning</p>
              </div>
              <div className="tech-card tech-card-3">
                <div className="tech-card-icon">🎯</div>
                <p>Smart Analytics</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Why Choose Parwaaz Academy?</h2>
            <p className="section-subtitle">What makes us truly unique</p>
          </div>
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">🎯</div>
              <h3>Holistic Approach</h3>
              <p>More than exam preparation—we provide a complete solution that develops students academically and prepares them for the modern world.</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🤖</div>
              <h3>AI-Driven Learning</h3>
              <p>State-of-the-art IT department with AI-driven learning tools matching international benchmarks from Europe and developed nations.</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">👥</div>
              <h3>Personalized Mentorship</h3>
              <p>Every student receives customized guidance. We work closely with each learner to turn their unique ambitions into reality.</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🌍</div>
              <h3>International Standards</h3>
              <p>Cutting-edge resources and global-level opportunities. Our technology matches practices implemented in developed nations.</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">💡</div>
              <h3>Skills Beyond Academics</h3>
              <p>We equip students with essential skills to navigate the ever-changing demands of the modern world and succeed in their careers.</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🎓</div>
              <h3>Future-Ready Programs</h3>
              <p>Programs carefully designed to align with industry trends, ensuring students are ready to succeed in their chosen careers.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Media Coverage Section */}
      <section id="media" className="media-coverage">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Media Coverage</h2>
            <p className="section-subtitle">Parwaaz Academy has been featured in top voices both nationally and internationally</p>
          </div>
          <div className="media-logos">
            <div className="media-logo">The Hindu</div>
            <div className="media-logo">BBC</div>
            <div className="media-logo">Economic Times</div>
            <div className="media-logo">NDTV</div>
            <div className="media-logo">The Indian Express</div>
            <div className="media-logo">CNN News18</div>
          </div>
          <p className="media-note">Stay updated with the latest news and events about Parwaaz Academy</p>
        </div>
      </section>

      {/* Study Resources Section */}
      <section id="resources" className="study-resources">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Study Resources</h2>
            <p className="section-subtitle">A diverse array of learning materials to enhance your educational journey</p>
          </div>
          <div className="resources-grid">
            <div className="resource-card">
              <div className="resource-icon">📚</div>
              <h3>Reference Books</h3>
              <p>Our experts have created thorough study materials that break down complicated concepts into easily understandable content.</p>
            </div>
            <div className="resource-card">
              <div className="resource-icon">📝</div>
              <h3>NCERT Solutions</h3>
              <p>Unlock academic excellence with Parwaaz Academy's NCERT Solutions which provide you step-by-step solutions.</p>
            </div>
            <div className="resource-card">
              <div className="resource-icon">📄</div>
              <h3>Notes & Study Material</h3>
              <p>Use Parwaaz Academy's detailed study materials that simplify complex ideas into easily understandable language.</p>
            </div>
            <div className="resource-card">
              <div className="resource-icon">📊</div>
              <h3>Mock Tests & PYQs</h3>
              <p>Comprehensive test series with previous year question papers and detailed performance analysis.</p>
            </div>
            <div className="resource-card">
              <div className="resource-icon">🎥</div>
              <h3>Video Lectures</h3>
              <p>Access recorded lectures and live interactive sessions to learn at your own pace.</p>
            </div>
            <div className="resource-card">
              <div className="resource-icon">💡</div>
              <h3>Doubt Solving</h3>
              <p>Get your doubts cleared instantly with dedicated doubt-solving sessions and expert guidance.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="testimonials">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Student Success Stories</h2>
            <p className="section-subtitle">Hear from our achievers</p>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-stars">★★★★★</div>
              <p className="testimonial-text">
                "Parwaaz Academy provided me with the right strategy and guidance for NEET. 
                The mock tests and doubt-clearing sessions played a huge role in my success!"
              </p>
              <div className="testimonial-author">
                <div className="author-avatar">AQ</div>
                <div className="author-info">
                  <div className="author-name">Amaan Qureshi</div>
                  <div className="author-title">NEET Achiever - 2023</div>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">★★★★★</div>
              <p className="testimonial-text">
                "Before joining Parwaaz Academy, I found Math really challenging. Thanks to 
                their expert guidance and structured approach, I now solve problems with confidence!"
              </p>
              <div className="testimonial-author">
                <div className="author-avatar">AK</div>
                <div className="author-info">
                  <div className="author-name">Ayesha Khan</div>
                  <div className="author-title">JEE Aspirant - 2024</div>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">★★★★★</div>
              <p className="testimonial-text">
                "The personalized attention I received at Parwaaz Academy helped me improve 
                in all subjects. Their teaching methods made learning easy and effective!"
              </p>
              <div className="testimonial-author">
                <div className="author-avatar">HM</div>
                <div className="author-info">
                  <div className="author-name">Hassan Mir</div>
                  <div className="author-title">12th Student</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="faq">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Frequently Asked Questions</h2>
            <p className="section-subtitle">Everything you need to know about Parwaaz Academy</p>
          </div>
          <div className="faq-container">
            <div className="faq-item">
              <button 
                className={`faq-question ${openFAQ === 0 ? 'active' : ''}`}
                onClick={() => setOpenFAQ(openFAQ === 0 ? null : 0)}
              >
                <span>Where are the campuses of Parwaaz Academy located?</span>
                <span className="faq-icon">{openFAQ === 0 ? '−' : '+'}</span>
              </button>
              <div className={`faq-answer ${openFAQ === 0 ? 'active' : ''}`}>
                <p>Parwaaz Academy has 1 campus located in Parraypora, Srinagar.</p>
              </div>
            </div>
            <div className="faq-item">
              <button 
                className={`faq-question ${openFAQ === 1 ? 'active' : ''}`}
                onClick={() => setOpenFAQ(openFAQ === 1 ? null : 1)}
              >
                <span>What courses does Parwaaz Academy offer?</span>
                <span className="faq-icon">{openFAQ === 1 ? '−' : '+'}</span>
              </button>
              <div className={`faq-answer ${openFAQ === 1 ? 'active' : ''}`}>
                <p>We provide coaching for 10th, 11th, 12th (Science & Commerce), NEET, and JEE (Mains & Advanced). Classes are available in both online and offline modes.</p>
              </div>
            </div>
            <div className="faq-item">
              <button 
                className={`faq-question ${openFAQ === 2 ? 'active' : ''}`}
                onClick={() => setOpenFAQ(openFAQ === 2 ? null : 2)}
              >
                <span>Do you offer online classes?</span>
                <span className="faq-icon">{openFAQ === 2 ? '−' : '+'}</span>
              </button>
              <div className={`faq-answer ${openFAQ === 2 ? 'active' : ''}`}>
                <p>Yes! We offer both online and offline classes. Our online platform provides live interactive sessions, recorded lectures, and doubt-solving support.</p>
              </div>
            </div>
            <div className="faq-item">
              <button 
                className={`faq-question ${openFAQ === 3 ? 'active' : ''}`}
                onClick={() => setOpenFAQ(openFAQ === 3 ? null : 3)}
              >
                <span>What are the class timings?</span>
                <span className="faq-icon">{openFAQ === 3 ? '−' : '+'}</span>
              </button>
              <div className={`faq-answer ${openFAQ === 3 ? 'active' : ''}`}>
                <p>We offer flexible class schedules with morning, afternoon, and evening batches. NEET and JEE classes are 40-45 mins per session, while 10th–12th coaching is 40-50 mins per session.</p>
              </div>
            </div>
            <div className="faq-item">
              <button 
                className={`faq-question ${openFAQ === 4 ? 'active' : ''}`}
                onClick={() => setOpenFAQ(openFAQ === 4 ? null : 4)}
              >
                <span>Do you provide study material and test series?</span>
                <span className="faq-icon">{openFAQ === 4 ? '−' : '+'}</span>
              </button>
              <div className={`faq-answer ${openFAQ === 4 ? 'active' : ''}`}>
                <p>Yes! We provide comprehensive study material for all courses. NEET and JEE students get a structured test series with mock exams and detailed performance analysis.</p>
              </div>
            </div>
            <div className="faq-item">
              <button 
                className={`faq-question ${openFAQ === 5 ? 'active' : ''}`}
                onClick={() => setOpenFAQ(openFAQ === 5 ? null : 5)}
              >
                <span>What is the fee structure?</span>
                <span className="faq-icon">{openFAQ === 5 ? '−' : '+'}</span>
              </button>
              <div className={`faq-answer ${openFAQ === 5 ? 'active' : ''}`}>
                <p>The fee structure varies based on the course and batch. For detailed fee information, please visit our campuses or contact us.</p>
              </div>
            </div>
            <div className="faq-item">
              <button 
                className={`faq-question ${openFAQ === 6 ? 'active' : ''}`}
                onClick={() => setOpenFAQ(openFAQ === 6 ? null : 6)}
              >
                <span>Is there any scholarship or discount available?</span>
                <span className="faq-icon">{openFAQ === 6 ? '−' : '+'}</span>
              </button>
              <div className={`faq-answer ${openFAQ === 6 ? 'active' : ''}`}>
                <p>Yes! We offer merit-based scholarships and financial assistance for deserving students. Discounts are available for early registrations and top performers.</p>
              </div>
            </div>
            <div className="faq-item">
              <button 
                className={`faq-question ${openFAQ === 7 ? 'active' : ''}`}
                onClick={() => setOpenFAQ(openFAQ === 7 ? null : 7)}
              >
                <span>How can I enroll at Parwaaz Academy?</span>
                <span className="faq-icon">{openFAQ === 7 ? '−' : '+'}</span>
              </button>
              <div className={`faq-answer ${openFAQ === 7 ? 'active' : ''}`}>
                <p>You can enroll by visiting our Parraypora campus or by registering online. For admission queries, contact us at:<br />
                📞 <a href="tel:+919103392946" style={{color: 'var(--primary-color)', textDecoration: 'none'}}>+91 9103392946</a><br />
                📧 <a href="mailto:info@parwaaz.live" style={{color: 'var(--primary-color)', textDecoration: 'none'}}>info@parwaaz.live</a><br />
                📍 Visit: Parraypora Campus, Srinagar</p>
                <p style={{marginTop: '1rem'}}>
                  <a href="https://my-skool.com/admission/PARWAAZ01" target="_blank" rel="noopener noreferrer" style={{
                    display: 'inline-block',
                    padding: '0.75rem 1.5rem',
                    background: 'var(--gradient-1)',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '50px',
                    fontWeight: '600',
                    marginTop: '0.5rem'
                  }}>
                    Register Online Now →
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Get In Touch</h2>
            <p className="section-subtitle">Start your journey with us today</p>
          </div>
          <div className="contact-content">
            <div className="contact-info">
              <h3>Contact Information</h3>
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div>
                  <h4>Address</h4>
                  <p>PARWAAZ ACADEMY<br />Parraypora, Srinagar<br />Jammu and Kashmir 190005</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div>
                  <h4>Phone</h4>
                  <p><a href="tel:+919103392946" style={{color: 'inherit', textDecoration: 'none'}}>+91 9103392946</a></p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">✉️</div>
                <div>
                  <h4>Email</h4>
                  <p><a href="mailto:info@parwaaz.live" style={{color: 'inherit', textDecoration: 'none'}}>info@parwaaz.live</a></p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">🕒</div>
                <div>
                  <h4>Timings</h4>
                  <p>Monday - Saturday: 9:00 AM - 7:00 PM<br />Sunday: 10:00 AM - 2:00 PM</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📝</div>
                <div>
                  <h4>Online Registration</h4>
                  <p>Register for admission online</p>
                  <a href="https://my-skool.com/admission/PARWAAZ01" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{marginTop: '0.75rem', display: 'inline-block'}}>
                    Register Now →
                  </a>
                </div>
              </div>
            </div>
            <div className="contact-registration">
              <div className="registration-content">
                <h3>Ready to Start Your Journey?</h3>
                <p>Register now for admission and join thousands of successful students at Parwaaz Academy.</p>
                <a href="https://my-skool.com/admission/PARWAAZ01" target="_blank" rel="noopener noreferrer" className="btn btn-primary registration-btn">
                  <span>Register for Admission</span>
                  <span className="btn-icon">→</span>
                </a>
                <p className="registration-note">Or contact us directly for more information</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Parwaaz Academy</h3>
              <p>More than just coaching—a complete solution for parents who aspire to give their children the best future. We transform ambitions into reality.</p>
              <div className="social-links">
                <a href="#" aria-label="Facebook">📘</a>
                <a href="#" aria-label="Instagram">📷</a>
                <a href="#" aria-label="Twitter">🐦</a>
                <a href="#" aria-label="LinkedIn">💼</a>
              </div>
            </div>
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About Us</a></li>
                <li><a href="#courses">Courses</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Courses</h4>
              <ul>
                <li><a href="#courses">Foundation Classes (8th-10th)</a></li>
                <li><a href="#courses">11th & 12th Classes</a></li>
                <li><a href="#courses">NEET & JEE Preparation</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Newsletter</h4>
              <p>Subscribe to get updates on new courses and events.</p>
              <form className="newsletter-form" onSubmit={(e) => {
                e.preventDefault();
                alert('Thank you for subscribing!');
                e.target.reset();
              }}>
                <input type="email" placeholder="Your Email" required />
                <button type="submit">Subscribe</button>
              </form>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Parwaaz Academy. All rights reserved.</p>
            <div className="footer-integrations">
              <div className="powered-by">
                <span className="powered-by-text">Powered by:</span>
                <div className="sarvam-logo">
                  <div className="sarvam-logo-icon">
                    <img src="/images/sarvam-logo.jpg" alt="Sarvam Kota Logo" />
                  </div>
                  <span className="sarvam-logo-text">Sarvam Kota</span>
                </div>
              </div>
              <div className="integrated-with">
                <span className="integrated-text">Integrated with</span>
                <a href="https://my-skool.com" target="_blank" rel="noopener noreferrer" className="myskool-link">
                  <span className="myskool-text">My-Skool.com</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
